import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'cap-functionbar',
  templateUrl: './functionbar.component.html',
  styleUrls: ['./functionbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FunctionbarComponent {}
